import { Router } from '@angular/router';
import { asFunction } from '../../abstract';

export function getPathFromUrl(url: string): string {
  return url.split('?')[0];
}

export const reloadPage = (router: Router): Promise<boolean> => {
  router.routeReuseStrategy.shouldReuseRoute = () => false;
  router.onSameUrlNavigation = 'reload';
  const currentUrl = router.url + '?';
  return router.navigateByUrl(currentUrl);
};

export const refreshPage = () => {
  location.reload();
};

export const hardReloadPage = (router: Router, callback: any = null) => {
  const currentUrl = router.url;
  router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
    router.navigate([currentUrl]).finally(() => asFunction(callback, currentUrl));
  });
};
